import { SectionHead } from '../../ui/SectionHead';
import './styles.css';
import GrowthIcon from '../../../assets/Icons/HowItWorks/trend-up-01.svg';
import PeopleIcon from '../../../assets/Icons/HowItWorks/users-01.svg';
import Rocket from '../../../assets/Icons/HowItWorks/rocket-02.svg';

export function HowItWorks() {
  const steps = [
    {
      num: '1',
      title: 'Create or Join',
      icon: Rocket,
      text: 'Set up your profile with your university, skills, and interests. Browse open projects or propose your own.',
    },
    {
      num: '2',
      title: 'Build Your Team',
      icon: PeopleIcon,
      text: 'Our algorithm matches you with complementary students from different countries and disciplines.',
    },
    {
      num: '3',
      title: 'Collaborate & Grow',
      icon: GrowthIcon,
      text: 'Use our built-in workspace to manage tasks, communicate, and deliver your project successfully.',
    },
  ];

  return (
    <section id="how" className="section howSection">
      <div className="container">
        <SectionHead
          align="center"
          title={
            <>
              How DaoCampus <span className="accent">Works</span>
            </>
          }
          subtitle="Start collaborating internationally in three simple steps."
        />

        <div className="howCards">
          {steps.map((step) => (
            <article className="howCard" key={step.num}>
              <div className="howCardTop">
                <div className="howIconWrap" aria-hidden="true">
                  <img src={step.icon} alt={step.title} className="howIcon" />
                </div>
                <span className="howStepNum">{step.num}</span>
              </div>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
